import { MESSAGE_KEY_ON_CAPTCHA_TOKEN } from "../../core/const/Constant";
import { subscribeMessageOnce } from "../../core/services/MessageService";
import FormModel from "../models/FormModel";
import Message from "./WindowMessage";

const [doRenderCaptcha, doGetRecaptchaToken] = (() => {
    /**
     * 
     * @param {FormModel} formModel 
     */
    const renderCaptcha = formModel => {
        const { recaptchaKey, recaptchaVersion, isExistCaptcha } = formModel;
        if (!isExistCaptcha) return Promise.resolve('');
        return Message.PostRenderReCapcha(recaptchaKey, recaptchaVersion)
    }
    /**
     * 
     * @param {FormModel} formModel 
     */
    const getRecaptchaToken = formModel => {
        if (!formModel.isExistCaptcha) { return Promise.resolve('') };
        return new Promise((next, reject) => {
            subscribeMessageOnce(MESSAGE_KEY_ON_CAPTCHA_TOKEN, next);
            setTimeout(() => {
                Message.PostTakeCapchaToken();
            });
        })
    }
    return [renderCaptcha, getRecaptchaToken];
})();

export {
    doRenderCaptcha,
    doGetRecaptchaToken
}